import { DefaultState, PageTemplateState, AppState } from './types.gen'
import { Map } from 'immutable'
import { IOWidget, Action, unloadedAsyncState, AsyncState, Widget, Option, none } from 'widgets-for-react'
import { TemplateState, Page } from '../page/types.gen'
import { CustomRouteParams, ExtraParameters } from '../router/type.gen'

export const SetCurrentWidget = <
  CustomBlockData extends { kind: CustomBlockData['kind'] },
  CustomBlocks extends { kind: CustomBlocks['kind'] },
  StandardBlocks,
  CurrentState extends DefaultState<CustomBlockData, CustomBlocks, StandardBlocks, extra_images, CustomPageData, PublicState>,
  CustomRoutes extends { kind: keyof CurrentState },
  extra_images,
  CustomPageData,
  PublicState
>(
  s: AppState<CurrentState, CustomRoutes>,
  newRoute: CustomRouteParams<CurrentState, CustomRoutes>,
  current_widget: Option<IOWidget<CurrentState, Action<CurrentState>>>
): AppState<CurrentState, CustomRoutes> => ({
  ...s,
  route: newRoute,
  current_widget: current_widget,
  state: {
    ...(s.state as any),
    page: { ...s.state.page, blocks: Map(), page: unloadedAsyncState() }
  }
})

export let PageStateZero = function<
  CustomBlockData extends { kind: CustomBlockData['kind'] },
  CustomBlocks extends { kind: CustomBlocks['kind'] },
  StandardBlock,
  extra_images,
  CustomPageData,
  PublicState
>(
  get_page: (slug: string, extra_params:ExtraParameters) => AsyncState<Page<CustomBlocks, StandardBlock, CustomPageData>>,
  display: (
    placeholder: Widget<
      Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>>
    >
  ) => Widget<Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>>>,
  pagedisplay: (
    page: (CustomBlocks | StandardBlock)[],
    public_state:PublicState
  ) => IOWidget<
    TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>,
    Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>>
  >
): PageTemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData, PublicState> {
  return {
    page: {
      custom_page_data:none(),
      get_page: get_page,
      page: unloadedAsyncState(),
      images: Map(),
      blocks: Map(),
      pagedisplay: pagedisplay,      
      display: display
    }
  }
}

export let DefaultStateZero = function<
  CustomBlockData extends { kind: CustomBlockData['kind'] },
  CustomBlocks extends { kind: CustomBlocks['kind'] },
  StandardBlock,
  extra_images,
  CustomPageData,
  PublicState
>(
  get_page: (slug: string, extra_params:ExtraParameters) => AsyncState<Page<CustomBlocks, StandardBlock, CustomPageData>>,
  display: (
    placeholder: Widget<
      Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>>
    >
  ) => Widget<Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>>>,
  pagedisplay: (
    page: (CustomBlocks | StandardBlock)[],
    public_state:PublicState
  ) => IOWidget<
    TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>,
    Action<TemplateState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData>>
  >
): DefaultState<CustomBlockData, CustomBlocks, StandardBlock, extra_images, CustomPageData, PublicState> {
  return {
    page: {
      custom_page_data:none(),
      get_page: get_page,
      images: Map(),
      blocks: Map(),
      page: unloadedAsyncState(),
      pagedisplay: pagedisplay,
      display: display
    }
  }
}
